<template>
    <div>

        <headerNav title="物料库"/>

        <div class="lgmian">
            
            <div class="money">
                <div class="money-left" @click="tz('/mywallet','1')">
                    <div>
                        <van-icon class="info-icon info-logistic-icon-left" :size="34" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="qian" />
                        <div>物料余额</div>
                        <div>(余额{{this.abp.userInfo.accessoriesLoans}})</div>
                    </div>
                </div>
                <div class="money-right" @click="goto">
                    <div>
                        <van-icon class="info-icon info-logistic-icon-right" :size="34" :color="$abctheme.basecolor" class-prefix="abc-icon"   name="qiandai" />
                        <div>返利小金库</div>
                        <div>(余额{{this.abp.userInfo.privateCoffer}})</div>
                    </div>
                </div>
            </div>

            <div class="cont-list" v-if="goodlist.length>0">
                <div class="cont-list-tit">物料商品</div>
                <van-pull-refresh  v-model="isLoading" @refresh="onRefresh">
                    <div class="cont-list-goods" v-for="(item,index) in goodlist" @click="navtodetail(item)" :key="index">
                        <div class="cont-list-goods-pic" >
                            <img  v-lazy="$baseurl+item.productImageUrl">
                        </div>
                        <div class="cont-list-goods-info">
                            <div class="setmar cont-list-goods-info-name">
                                {{item.pName}}
                            </div>
                            <div class="setmar cont-list-goods-info-price">
                                ￥<span class="cont-list-goods-info-price-wz">{{item.price}}</span>
                            </div>
                            <div class="setmar cont-list-goods-info-gz">
                                规格可选{{item.skus.length}}
                            </div>
                        </div>
                        <div class="cont-list-goods-btns">
                            <van-icon name="cart-circle-o" size="38"  color="#f9da33"/>
                        </div>
                    </div>
                </van-pull-refresh>
            </div>
        </div>
        
    <!-- <navigate /> -->
    </div>
</template>
<script>
import request from "../../config/ajax";
export default {
    data(){
        return {
            isLoading:false,
            topheight:0,
            page:{
                // BackgroundColor:"#f9da33"
            },
            carouselList:[],
            goodreq:
            {
                maxResultCount: 5,
                skipCount: 0,
                productType:1
            },
            goodlist:[]
        }
    },
    created(){
        this.getgoodlist();
    },
    methods:{
        onRefresh()
        {
            this.getgoodlist();
        },
        //拉取产品
        getgoodlist()
        {
            //分页获取
            request.post("/api/services/app/PhoneCom/QueryProductList", this.goodreq).then((x) => {
               
               this.goodreq.skipCount+=this.goodreq.maxResultCount;
               var  goods = x.result.items;
               this.goodlist=this.goodlist.concat(goods);
               //console.log(this.goodlist);
            
            }).finally(()=>
            {
                this.isLoading=false;
            });
        },
        navtodetail(item)
        {
            //console.log(this.$router);
            var productsku=item.productSku;
            this.$router.push({path:'/product/'+productsku});
        },
        tz(url,ctype)
        {
            if(ctype)
            {
                this.$router.push({path:url,query:{ctype:ctype}});
            }
            else
            {
                this.$router.push({path:url});
            }
        },
        goto()
        {
            this.$router.push({
                path: '/coffer'
            });
        }
    }
}
</script>

<style  lang="scss" scoped>
  .lgmian
  {
      margin:0 10px 0 10px;
  }
  
  .money{
      
      font-size: 14px;
      margin: 10px 0 15px 0;
      border-radius: 4px;
      box-shadow: 1px 1px 4px #ccc;
      padding: 10px;
      position: relative;
      background-color: #fff;
  }
  .info-icon
  {
      position:absolute;
      top: 50%;
      transform: translate(0,-50%);
  }
  .info-logistic-icon-left{
       left: 10px;
  }
  .money-left{
      position: relative;
      padding-left: 50px;
      display: inline-block;
      padding-right: 40px;
      border-right: 1px solid #dedede;
  }
  .info-logistic-icon-right{
      left: 20px;
  }

  .money-right{
        display: inline-block;
        padding-left: 60px;
        position: relative;
  }


 .cont-list
 {
     background-color: #fff;
     font-size: 14px;
     padding: 10px;
     color:#86751b;
     border-radius: 4px;
     box-shadow: 1px 1px 4px #ccc;
 }
 .cont-list-tit
 {
    margin-bottom:10px;
    font-weight: bold;
 }
 .cont-list-goods
 {
     position: relative;
 }
 .cont-list-goods-pic
 {
     position: absolute;
     left: 0;
     width: 100px;
     height: 100px;
 }
 .cont-list-goods-pic img
 {
     width: 100%;
     height: 100%;
     border-radius: 4px;
 }
 .cont-list-goods-info
 {
     padding-left: 115px;
 }
 .cont-list-goods-info-price
 {
     color: red;
     font-weight: bold;
     font-size:13px;
 }
 .cont-list-goods-info-price-wz
 {
     font-size:16px ;
 }
 .cont-list-goods-info-gz
 {
     color: silver;
 }
 .cont-list-goods-btns
 {
     position: absolute;
     right: 10px;
     bottom: 0;
 }
 .setmar
 {
     margin-bottom: 20px;
 }
</style>
